import { languageConfigs } from "@/lang/languages";
import type { SupportedLanguage } from "@/types/i18n";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";

export const LanguageSelect: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = async (value: string) => {
    console.log(`Changing language from ${i18n.language} to ${value}`);
    await i18n.changeLanguage(value as SupportedLanguage);
  };

  const currentLanguage = i18n.language as SupportedLanguage;
  const currentOption = languageConfigs[currentLanguage] || languageConfigs.en;
  const availableLanguages = Object.entries(languageConfigs).filter(
    ([key, lang]) => key !== currentLanguage,
  );

  return (
    <div className="flex items-center">
      <Select
        value={currentLanguage}
        onValueChange={handleLanguageChange}
        disabled={!i18n.isInitialized}
      >
        <SelectTrigger className="bg-blue-darker border-blue-darker w-[160px] text-white">
          <SelectValue>
            <div className="flex items-center gap-2">
              {/* <img
                src={currentOption.flagIcon}
                alt={`${currentOption.nativeName} flag`}
                className="h-6 w-6"
              /> */}
              <span className="">{currentOption.nativeName}</span>
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="bg-blue-darker border-blue-darker text-white">
          <SelectGroup>
            {availableLanguages.map(([key, lang]) => (
              <SelectItem
                key={key}
                value={key}
                className="focus:bg-blue-dark-hover focus:text-blue-light cursor-pointer"
              >
                <div className="flex w-full items-center gap-2">
                  {/* <img
                    src={lang.flagIcon}
                    alt={`${lang.nativeName} flag`}
                    className="h-6 w-6"
                  /> */}
                  <div className="flex flex-col">
                    <span className="">{lang.nativeName}</span>
                  </div>
                </div>
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
